<template>

  <div
    class=" lighten-3"
    id="e3"
  >
    <v-container
      fluid
      grid-list-lg
    >

      <v-timeline dense>
        <v-timeline-item
          :key="i" large
          v-for="item,  i in items"

        >

          <!--<span class="headline font-weight-bold " slot="opposite">{{item.data}} </span>-->

          <v-layout row wrap>
            <v-flex xs12>
              <v-card>
                <v-card-title class="title subprimary">
                  <span class="title font-weight-bold">{{item.data}} {{item.title}} </span>
                </v-card-title>

                <v-card-text class=" text-xs-left title" v-html="item.text">
<!--                  "{{item.text}}"-->
                </v-card-text>
                <v-card-actions>
                  <v-list-tile class="grow">
                    <v-list-tile-avatar color="white">
                      <v-img
                        aspect-ratio="1"  contain
                        :src="logo"
                        alt="logo" class="elevation-6"
                      ></v-img>
                    </v-list-tile-avatar>

                    <v-list-tile-content>
                      <v-list-tile-title>
                        EIOS developers
                      </v-list-tile-title>
                    </v-list-tile-content>

                  </v-list-tile>
                </v-card-actions>
              </v-card>

            </v-flex>
          </v-layout>

        </v-timeline-item>
      </v-timeline>

    </v-container>

  </div>

</template>

<script>
  import logo from "@/assets/logo.png";

  export default {
    name: "InfoUpdate",
    data: function () {
      return {
        logo: logo,
        items: [

          {
            data: '07.02.2020',
            title: 'Запуск системы',
            text: '<div>Уважаемые пользователи! 25 февраля 2020 открылся Единый личный кабинет РХТУ им. Д,И. Менделеева.</div>' +
              '<div>Теперь Вы можете заполнить актуальную информацию о себе, а так же создавать и управлять корпоративными почтовыми ящиками. </div>' +
              '<div class="pt-3">С уважением, Команда разработчиков</div>',
          },

        ]
      }
    }
  }
</script>

<style scoped>

</style>
